import { Seo, ORG_JSONLD, SERVICE_JSONLD, faqJsonLd } from "@/lib/Seo";
import { FAQS } from "@/data/content";
import { Hero } from "@/sections/Hero";
import { Problem } from "@/sections/Problem";
import { SmokeBanner } from "@/sections/SmokeBanner";
import { WhyThermal } from "@/sections/WhyThermal";
import { FlamesVideo } from "@/sections/FlamesVideo";
import { DemoSection } from "@/sections/DemoSection";
import { HowItWorks } from "@/sections/HowItWorks";
import { SystemSchema } from "@/sections/SystemSchema";
import { Applications } from "@/sections/Applications";
import { WorkMethod } from "@/sections/WorkMethod";
import { Benefits } from "@/sections/Benefits";
import { Reliability } from "@/sections/Reliability";
import { FAQSection } from "@/sections/FAQSection";
import { ContactSection } from "@/sections/ContactSection";

export default function Home() {
  return (
    <>
      <Seo
        title="Thermische branddetectie recycling | Hikvision"
        description="Detecteer afwijkende warmteontwikkeling met Hikvision thermische camera's voor recyclingbedrijven. Vraag een locatie analyse en offerte aan."
        jsonLd={[ORG_JSONLD, SERVICE_JSONLD, faqJsonLd(FAQS)]}
      />
      <Hero />
      <Problem />
      <SmokeBanner />
      <WhyThermal />
      <FlamesVideo />
      <DemoSection />
      <HowItWorks />
      <SystemSchema />
      <Applications />
      <WorkMethod />
      <Benefits />
      <Reliability />
      <FAQSection />
      <ContactSection />
    </>
  );
}
